import { Component, ChangeDetectionStrategy } from '@angular/core';
import { INoRowsOverlayAngularComp } from 'ag-grid-angular';

@Component({
  selector: 'ml-list-no-rows-result',
  templateUrl: './list-no-rows-result.component.html',
  styleUrls: ['./list-no-rows-result.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: true,
})
export class ListNoRowsResultComponent implements INoRowsOverlayAngularComp {
  // Required by INoRowsOverlayAngularComp interface - no initialization needed
  agInit(): void {
    // Intentionally empty - component uses template only
  }
}
